import React from 'react';
import { Box, Card, CardContent, styled, Message } from '@invision/ui';
import { useTranslation } from '@invision/core';
import { getEnvironmentDetails } from '../../utils';
import InvisionLogoSvg from '@invision/ui/src/icons/invision-logo.svg';
import invisionLoginBackground from '@invision/ui/src/images/invision_login_background.jpg';
import { CopyrightFooter } from './CopyrightFooter';
// @ts-ignore
import { PACKAGE_VERSION } from '../../version';

const AuthenticationPageContainer = styled(Box)`
  min-height: 100vh;
  background: #413c39 url(${invisionLoginBackground});
  background-repeat: no-repeat;
  background-size: cover;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
`;

interface AuthenticationLayoutProps {
  children: React.ReactNode;
}
export function AuthenticationLayout({ children }: AuthenticationLayoutProps) {
  const { t } = useTranslation();
  const { hasEnvironmentError } = getEnvironmentDetails();

  return (
    <AuthenticationPageContainer>
      <Card sx={{ width: 400, margin: 'auto' }}>
        <Box
          sx={{
            background: '#fff',
            py: 2.5,
            textAlign: 'center',
            borderBottom: 1,
            borderColor: 'grey.300'
          }}
        >
          <InvisionLogoSvg
            style={{
              maxWidth: '250px',
              height: 'auto',
              imageRendering: 'crisp-edges',
              shapeRendering: 'crispEdges'
            }}
            aria-label={t('Invision Logo')}
          />
        </Box>

        <CardContent sx={{ p: 3.75 }}>
          {hasEnvironmentError && (
            <Box sx={{ mb: 2 }}>
              <Message
                variant="error"
                messages={[
                  t(
                    'Unable to determine environment from hostname. Please contact support if this persists.'
                  )
                ]}
              />
            </Box>
          )}

          {children}
        </CardContent>
      </Card>

      <Box
        sx={{
          position: 'absolute',
          bottom: 0,
          left: 0,
          right: 0,
          width: '100%'
        }}
      >
        <CopyrightFooter version={PACKAGE_VERSION} />
      </Box>
    </AuthenticationPageContainer>
  );
}
